"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XjbInfo = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var zl_1 = require("../../model/zl");
var service_1 = require("../../../library/base/service");
var XjbInfo = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(XjbInfo, _super);
    function XjbInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '现金宝持有信息查询';
        _this.code = '106001';
        _this.desc = '现金宝持有信息查询';
        _this.requestParams = new zl_1.XjbInfoRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return XjbInfo;
}(service_1.BaseService));
exports.XjbInfo = XjbInfo;
//# sourceMappingURL=xjbInfo.js.map